import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/Home.vue'
import Associated from './views/Associated.vue'
import WorkWithUs from './views/WorkWithUs.vue'
import qualificationForm from './views/qualificationForm2.vue'
import HowMuch from './views/HowMuch'
import offPF from './views/offPF.vue'
import $ from 'jquery'

Vue.use(Router)

// function lazyLoad(view) {
//     return () =>
//         import (`@/views/${view}.vue`)
// }

export default new Router({
    mode: 'history',

    routes: [
        {
            path: '/',
            name: 'home',
            component: Home
        },   
        {
            path: '/seja-um-franqueado',
            name: 'associado',
            component: Associated
        },
        {
            path: '/vagas',
            name: 'WorkWithUs',
            component: WorkWithUs
        },
        {
            path: '/calculadora',
            name: 'HowMuch',
            component: HowMuch
        },
        {
            path: '/formulario',
            name: 'qualificationForm',
            component: qualificationForm
        },
        {
            path: '/unidadesdesligadas',
            name: 'desligadas',
            component: offPF
        },
        // {
        //     path: '/noticias',
        //     name: 'noticias',
        //     component: lazyLoad('noticias')
        // },
       
        
    ],
    scrollBehavior:o=>(o.params.tabId||$("html, body").animate({scrollTop:0},{duration:"slow"}))

});
